import {eventDetailSSR} from "@QUERIES/prdt/event/useEventDetail";
import {goodsDetailSSR} from "@QUERIES/prdt/goods/useGoodsDetail";
import {GetServerSidePropsContext} from "next/types";
import {TDetailPackage} from "@COMPONENTS/partners/types";

/** 컴포넌트 */
import DetailPrice from "@COMPONENTS/partners/pages/detailPackage/mobile/detailPrice";
import DetailScheduleSummary from "@COMPONENTS/partners/pages/detailPackage/mobile/detailScheduleSummary";
import DetailSchedule from "@COMPONENTS/partners/pages/detailPackage/mobile/detailSchedule";
import GmarketDetailHeader from "@COMPONENTS/partners/pages/detailPackage/mobile/GmarketDetailHeader";

const Page = (props: TDetailPackage) => (
	<div id="container">
		<GmarketDetailHeader eventDetail={props.eventDetail} />
		<DetailScheduleSummary {...props} />
		<DetailPrice {...props} />
		<DetailSchedule {...props} isFixed={false} />
	</div>
);

const getServerSidePropsSSR = async (evCd: string) => {
	const goodsCd = evCd.substring(0, 7);

	const eventDetailPromise = await eventDetailSSR(evCd);
	const eventDetail = eventDetailPromise.data.body || null;

	const goodsDetailPromise = await goodsDetailSSR(goodsCd);
	const goodsDetail = goodsDetailPromise.data.body || null;
	return {
		eventDetail,
		goodsDetail,
	};
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
	const {query} = ctx;
	const pageQuery: TDetailPackage["query"] = {...(query as TDetailPackage["query"])};
	const data = await getServerSidePropsSSR(pageQuery.evCd);
	return {
		props: {
			query: pageQuery,
			...data,
		},
	};
}

export default Page;
